import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  className?: string;
}
export function Badge({
  children,
  className = ''
}: BadgeProps) {
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#1a1a1a] text-gray-300 border border-[#333] ${className}`} data-id="element-156">
      {children}
    </span>;
}